module.exports = __webpack_public_path__ + "static/media/scr_onboarding_status_Bar_Ios.e7606e0b.png";